var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseWorth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h30v30H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#80959D",
    d: "M7.639 1c.149 0 .298.046.437.137.276.181.463.534.465.927v.006a.39.39 0 0 0 .26.368.365.365 0 0 0 .182.011.366.366 0 0 0 .26-.196.39.39 0 0 0 .044-.183l-.001-.006c.002-.393.188-.746.465-.927a.769.769 0 0 1 .875 0c.277.182.465.537.465.933a.39.39 0 0 0 0 .027.39.39 0 0 0 .128.266.37.37 0 0 0 .348.077.367.367 0 0 0 .184-.125.384.384 0 0 0 .084-.245c0-.396.189-.751.466-.933a.766.766 0 0 1 .874 0c.275.18.461.53.465.921l-.001.012a.39.39 0 0 0 .13.293.37.37 0 0 0 .237.094.365.365 0 0 0 .144-.028l.003-.002a.39.39 0 0 0 .233-.357l-.002-.012c.004-.39.19-.74.465-.921a.766.766 0 0 1 .874 0c.274.18.46.53.465.92-.008 1.149-.462 2.253-1.28 3.119H8.018c-.817-.866-1.272-1.97-1.28-3.12.005-.39.191-.74.466-.92A.79.79 0 0 1 7.639 1zm.774 6.253h6.174c5.89 4.716 7.413 9 7.413 12.194v.368c0 1.369-1.008 2.65-2.757 3.613C17.495 24.39 15.036 25 12.305 25h-1.61c-2.73 0-5.19-.61-6.938-1.572C2.008 22.466 1 21.184 1 19.815v-.368c0-3.194 1.524-7.478 7.413-12.194zm2.735 4.456c-2.9 0-5.236 2.344-5.236 5.218a5.228 5.228 0 0 0 5.236 5.221c2.9 0 5.264-2.343 5.264-5.22a.347.347 0 0 0-.027-.135 5.235 5.235 0 0 0-5.237-5.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M9.017 14v.007H9v.75h.822c.748 0 1.127.331 1.263.743H9.017v.75h2.068c-.136.411-.514.743-1.263.743H9.54l-.005-.004-.004.004H9v.75h.213L11.682 20l.56-.536-1.932-1.766c.879-.167 1.443-.777 1.597-1.449H13v-.75h-1.093a1.81 1.81 0 0 0-.385-.75H13V14H9.017z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseWorth);
export default __webpack_public_path__ + "static/media/purchase-worth.26339fa6dd44f34db9503cd94dc9b9cb.svg";
export { ForwardRef as ReactComponent };